import { render } from "./ManufacturerProducts.vue?vue&type=template&id=d8626190&scoped=true"
import script from "./ManufacturerProducts.vue?vue&type=script&lang=js"
export * from "./ManufacturerProducts.vue?vue&type=script&lang=js"

import "./ManufacturerProducts.vue?vue&type=style&index=0&id=d8626190&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8626190"]])

export default __exports__